module.exports = __webpack_public_path__ + "img/shape3_new.13744ee6.png";